<template>
  <div class="p-6 flex-grow-1 container-p-y">
    <div class="card">
      <div class="card-datatable mt-6">
        <div class="dataTables_scroll" bis_skin_checked="1">
          <div
            class="dataTables_scrollBody table-container"
            bis_skin_checked="1"
            style="position: relative; overflow: auto; width: 100%; height: 480px;"
          >
            <table
              class="dt-scrollableTable table"
              id="DataTables_Table_0"
              aria-describedby="DataTables_Table_0_info"
            >
              <thead
                style="background-color: var(--bs-card-bg);"
                class="sticky top-0 z-50"
              >
                <tr class="text-nowrap">
                  <th class="sorting">{{ $t("sservices.service") }}</th>
                  <th class="sorting">{{ $t("sservices.status") }}</th>
                  <th class="sorting">{{ $t("sservices.actions") }}</th>
                </tr>
              </thead>
              <tbody class="table-border-bottom-0 ">
                <tr v-for="(service, index) in services" :key="index">
                  <td class="font-bold">
                    {{ service.name }}
                  </td>
                  <td>
                    <span
                      class="badge bg-label-success me-1"
                      :class="{
                        'bg-label-success': service.status == 'active',
                        'bg-label-danger': service.status == 'inactive',
                      }"
                      >{{ $t(`sservices.${service.status}`) }}</span
                    >
                  </td>
                  <td>
                    <div
                      class="btn btn-warning btn-sm m-1"
                      v-if="service.status == 'active'"
                      @click="restartService(service.name)"
                    >
                      {{ $t("sservices.restart") }}
                    </div>
                    <div
                      class="btn btn-danger btn-sm m-1"
                      v-if="service.status == 'active'"
                      @click="stopService(service.name)"
                    >
                      {{ $t("sservices.stop") }}
                    </div>
                    <div
                      class="btn btn-success btn-sm m-1"
                      v-if="service.status == 'inactive'"
                      @click="startService(service.name)"
                    >
                      {{ $t("sservices.start") }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "SServices",
  created() {
    this.fetchServices();
  },
  data() {
    return {
      services: [
        { name: "ssradius_tunnel", status: "inactive" },
        { name: "mysql", status: "inactive" },
        { name: "freeradius", status: "inactive" },
      ],
    };
  },
  methods: {
    async fetchServices() {
      const response = await axios.get("services");
      if (response.status === 200) {
        this.services = response.data.data;
      }
    },
    async restartService(service) {
      try {
        const response = await axios.post("services/restart", {
          service: service,
        });
        if (response.status === 200) {
          this.$notify({
            text: this.$t("sservices.restarted_successfully"),
            type: "success",
          });
          this.fetchServices();
        }
      } catch (error) {
        this.$notify({
          text: this.$t("sservices.operation_failed"),
          type: "error",
        });
      }
    },
    async startService(service) {
      try {
        const response = await axios.post("services/start", {
          service: service,
        });
        if (response.status === 200) {
          this.$notify({
            text: this.$t("sservices.started_successfully"),
            type: "success",
          });
          this.fetchServices();
        }
      } catch (error) {
        this.$notify({
          text: this.$t("sservices.operation_failed"),
          type: "error",
        });
      }
    },
    async stopService(service) {
      try {
        const response = await axios.post("services/stop", {
          service: service,
        });
        if (response.status === 200) {
          this.$notify({
            text: this.$t("sservices.stopped_successfully"),
            type: "success",
          });
          this.fetchServices();
        }
      } catch (error) {
        this.$notify({
          text: this.$t("sservices.operation_failed"),
          type: "error",
        });
      }
    },
  },
};
</script>
